let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("49f46")).then(() => parcelRequire('5IqdJ'));